import React from "react";
import {SuccessIcon, WarningIcon, ErrorIcon, InfoIcon} from '../SidebarNavigation/utils/icons';

class Messages extends React.Component {
    renderIcon(variant) {
        if (variant === 'success') return <SuccessIcon />;
        if (variant === 'warning') return <WarningIcon />;
        if (variant === 'error') return <ErrorIcon />;
        return <InfoIcon />;
    }

    render() {
        const { style, variant, title, description } = this.props;
        return (
            <div className={`in-context-alert`} style={style}>
                {this.renderIcon(variant)}
                <div>
                    <h4>{title}</h4>
                    <p>{description}</p>
                </div>
            </div>
        );
    }
}

export default Messages;


// WEBPACK FOOTER //
// ./src/components/pages/in-context/components/Messages.js